import { formatCurrencyAmount } from '@/lib/formatMoney';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export interface MrrByTierRow {
  tier: string;
  currency: string;
  mrr: number;
  subscriberCount: number;
}

export function MrrByTierTable({ rows }: { rows: MrrByTierRow[] }) {
  if (rows.length === 0) {
    return <p className="py-8 text-center text-sm text-muted-foreground">No paid tiers with active subscriptions.</p>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Plan</TableHead>
          <TableHead>Currency</TableHead>
          <TableHead>MRR</TableHead>
          {/* "Subscriptions", matching RecurringRevenueTable: both count
              active paid subscription rows. "Subscribers" read as a count of
              customers, which is a different number (the Churn panel and the
              MRR movement chart count groups, and say so). */}
          <TableHead>Subscriptions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={`${row.tier}-${row.currency}`}>
            <TableCell className="font-medium">{row.tier}</TableCell>
            <TableCell>{row.currency}</TableCell>
            <TableCell>{formatCurrencyAmount(row.mrr, row.currency)}</TableCell>
            <TableCell className="text-muted-foreground">{row.subscriberCount}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
